import * as React from 'react';
import SimpleLogin from '../SimpleLogin';
import Welcome from './Welcome';
import { useAuthProvider } from 'react-admin';
import { useState } from 'react';
import { Box, Stack } from '@mui/material';
import MarkdownCard from './MarkdownCard';
import examplesMdUri from './examples.md';
import Copyright from './Copyright';
import getExamplePublicJobs from './getExamplePublicJobs';

const AboutList = () => {
    const authProvider = useAuthProvider();
    const [userId, setUserId] = useState(undefined)
    const [userName, setUserName] = useState(undefined)

    authProvider.getIdentity().then((identity) => {
        setUserId(identity.id);
        setUserName(identity.name);
    }).catch(() => {
        setUserId(null);
        setUserName(null);
    })

    const examplePublicJobsList = getExamplePublicJobs();

    return (
        <Stack spacing='1em'>

            <Welcome userName={userName} />
            {!userId && <SimpleLogin />}
            <MarkdownCard uri={examplesMdUri} />
            {examplePublicJobsList}
            <Copyright />

            <Box pt='1em'/>
        </Stack>
    )
};


export default AboutList;
